import { Reveal, Eyebrow } from "./Reveal";
import { STORE_PHOTOS, LANGUAGES } from "../config/site";

const PHOTOS = [
  {
    id: "interior",
    src: STORE_PHOTOS.interior,
    alt: "Inside Om Sri Sri Collection store — footwear, garments, bags and essentials on display",
    caption: "Inside the store",
    span: "md:col-span-8",
    h: "h-72 sm:h-[26rem]",
  },
  {
    id: "kurtis",
    src: STORE_PHOTOS.kurtis,
    alt: "Colourful kurtis and ladies' wear on the rack at Om Sri Sri Collection",
    caption: "Ladies' wear rack",
    span: "md:col-span-4",
    h: "h-72 sm:h-[26rem]",
  },
  {
    id: "bags",
    src: STORE_PHOTOS.bags,
    alt: "Printed handbags, sling bags and travel pouches at Om Sri Sri Collection",
    caption: "Bags & travel pouches",
    span: "md:col-span-7",
    h: "h-64 sm:h-80",
  },
  {
    id: "sports-bag",
    src: STORE_PHOTOS.sportsBag,
    alt: "Close-up of a sports sling bag available at Om Sri Sri Collection",
    caption: "Everyday carry",
    span: "md:col-span-5",
    h: "h-64 sm:h-80",
  },
];

export const StoreGallery = () => (
  <section id="store" className="py-16 sm:py-24 lg:py-32 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-5">
        <div className="max-w-xl">
          <Eyebrow>Real Store. Real Stock.</Eyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-cream text-balance">
            A glimpse inside Om Sri Sri Collection.
          </h2>
        </div>
        <p className="text-sm sm:text-base text-cream/50 max-w-xs leading-relaxed">
          Photographed at our Udayapura store on Kanakapura Main Road — what you
          see is what's on the shelves.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-5 lg:gap-6">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.id} delay={(i % 2) * 0.1} className={p.span}>
            <figure
              data-testid={`store-photo-${p.id}`}
              className={`group relative ${p.h} rounded-3xl overflow-hidden border border-white/10 img-frame`}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.05]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-transparent to-transparent" />
              <figcaption className="absolute bottom-5 left-6 font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-gold">
                {p.caption}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="languages-strip"
          className="mt-10 rounded-3xl border border-gold/25 bg-gold/[0.06] px-6 sm:px-9 py-7 flex flex-col lg:flex-row lg:items-center gap-6"
        >
          <div className="lg:w-72 shrink-0">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
              We speak your language
            </p>
            <p className="mt-2 text-sm text-cream/60 leading-relaxed">
              Shop comfortably in Hindi, Kannada, English, Rajasthani or Haryanvi.
            </p>
          </div>
          <ul className="flex flex-wrap gap-2.5">
            {LANGUAGES.map((l) => (
              <li
                key={l.name}
                data-testid={`language-chip-${l.name.toLowerCase()}`}
                className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-charcoal/60 px-4 py-2 text-sm text-cream/85"
              >
                <span className={`${l.font} text-gold`}>{l.native}</span>
                {l.name !== "English" && (
                  <span className="text-cream/45 text-xs">{l.name}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
